import React from 'react';

import SvgContainer from '../SvgContainer';

const CalendarNoWorkouts = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100961)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.689 1.45455H12.9186V0.770345C12.9186 0.344895 12.5737 0 12.1483 0C11.7228 0 11.3779 0.344895 11.3779 0.770344V1.45455H5.21517V0.770344C5.21517 0.344895 4.87028 0 4.44483 0C4.01938 0 3.67448 0.344895 3.67448 0.770344V1.45455L7.5262 5.09091H13.189C13.4651 5.09091 13.689 5.31477 13.689 5.59091V10.9952L15.2296 12.4294V2.90909C15.2296 2.10909 14.5363 1.45455 13.689 1.45455ZM3.46649 5.09091L1.371 3.11258L1.36345 13.0909C1.36345 13.8909 2.04906 14.5455 2.90414 14.5455H13.481L11.9403 13.0909H3.40414C3.128 13.0909 2.90414 12.8671 2.90414 12.5909V5.59091C2.90414 5.31477 3.128 5.09091 3.40414 5.09091H3.46649Z"
                />
                <path d="M4.44483 9.18182C4.44483 9.7341 4.89254 10.1818 5.44483 10.1818H7.76564C8.05885 10.1818 8.29655 9.94412 8.29655 9.65091L5.00718 6.54545C4.6966 6.54545 4.44483 6.79723 4.44483 7.10781V9.18182Z" />
                <path d="M14.5606 15.5647C14.8194 15.8091 15.2239 15.8091 15.4827 15.5647C15.7635 15.2997 15.7635 14.8531 15.4827 14.588L13.689 12.8945L5.42316 5.09091L1.4394 1.32983C1.18058 1.08549 0.776089 1.08548 0.517275 1.32983C0.23653 1.59488 0.236525 2.04149 0.517265 2.30655L1.371 3.11258L3.46649 5.09091L5.00718 6.54545L8.29655 9.65091L11.9403 13.0909L13.481 14.5455L14.5606 15.5647Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100961">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default CalendarNoWorkouts;
